<template>
    <div class="footer">
        <div class="footer-left" @click="checkOption(1)">
            <van-icon v-if="option===1" class="footer-icon" size="22" name="/referral/code.png"/>
            <van-icon v-else class="footer-icon" size="22" name="/referral/code-no.png"/>
            <div v-if="option===1" class="footer-text" style="color: #F94B54">邀请码</div>
            <div v-else class="footer-text">邀请码</div>
        </div>
        <div class="footer-centre" @click="checkOption(2)">
            <van-icon v-if="option===2" class="footer-icon" size="22" name="/referral/bag.png"/>
            <van-icon v-else class="footer-icon" size="22" name="/referral/bag-no.png"/>
            <div v-if="option===2" class="footer-text" style="color: #F94B54">收益</div>
            <div v-else class="footer-text">收益</div>
        </div>
        <div class="footer-right" @click="checkOption(3)">
            <van-icon v-if="option===3" class="footer-icon" size="22" name="/referral/my.png"/>
            <van-icon v-else class="footer-icon" size="22" name="/referral/my-no.png"/>
            <div v-if="option===3" class="footer-text" style="color: #F94B54">我的</div>
            <div v-else class="footer-text">我的</div>
        </div>
    </div>
</template>

<script setup>
import {ref, defineProps} from 'vue';
import {useRouter} from "vue-router";
const router = useRouter()
const props = defineProps(['index'])
const option = ref(parseInt(props.index))

const checkOption = (val)=>{
    if(val===1){
        option.value = 1;
        router.push({ path: '/referral/index'});
    }else if(val===2){
        option.value = 2;
        router.push({ path: '/referral/income'});
    }else{
        option.value = 3;
        router.push({ path: '/referral/my'});
    }
};

</script>
<style scoped lang="scss">
.footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 55px;
    border-top: 1px solid #F6F6F6;
    background: #FFFFFF;

    .footer-left{
        width: 33%;
        height: 55px;
        //background: #F94B54;
        float: left;
        text-align: center;
        border-right: 1px solid #fff;
        //border-right: 1px solid #F6F6F6;
    }
    .footer-centre{
        width: 33%;
        float: left;
        height: 55px;
        text-align: center;
        border-right: 1px solid #fff;
    }
    .footer-right{
        width: 33%;
        height: 55px;
        float: left;
        text-align: center;
    }
    .footer-icon{
        margin-top: 10px;
    }
    .footer-text{
        font-size: 10px;
    }
}
</style>
